import './alertsSummary.less'
import {
  ACTION_ALERTS_STALED_WIDGET,
  AlertsSummaryParams,
  AlertStaled,
  fetchAlertsStaledWidget,
  fetchAlertsCritical,
  resetWidgets as resetWidget,
  AlertCritical
} from './../../../alerts/alertsSlice'
import ChartBarSimple from '../../../../components/ChartBarSimple/chartBarSimple'
import { formatDateTimeStringToPrettyDateTimeWithoutPrefix } from '../../../../utils/timeUtil'
import useUrlContext from '../../../../hooks/useUrlContext'
import {
  DATA_SOURCE_ID,
  IS_UNRESOLVED,
  URL_ALERTS,
  URL_POLICIES,
  DRIVE_ID,
  DATA_SOURCE_TYPE,
  FILTER_DATA_SOURCE_TYPE_KEY,
  PAGE_VIEW_KEY,
  PAGE_VIEW_VALUES,
  DATABASE_ID,
  URL_OVERVIEW,
  FILTER_PARTNER_ID_KEY,
  ALERT_STATUS_API_MAP,
  ALERT_STATUS,
  alertIntermediateStatuses,
  DATA_SOURCE_TYPES
} from '../../../../constants'
import { RootState } from '../../../../rootReducer'
import LoaderView from '../../../../components/Loader/loader'
import { getShowLoader } from '../../../../reducers/requestReducer'
import { changeUrl, getUpdatedUrl } from '../../../../utils/urlUtil'
import NoAlertsSvg from '../../../../assets/inlineSvg/no_alerts.svg'
import { FilterParams } from '../../../../interfaces'
import { ChartColors, getUniqueWidgetIndex, UNIQUE_WIDGET_INDEX } from '../constants'
import { mockAlertSummaryWidgetData } from '../../renderer/utils/widgetMockdata'
import { useIntl } from 'react-intl'
import { connect } from 'react-redux'
import Carousel from 'react-multi-carousel'
import { CaretLeft as SvgCaretLeft, CaretRight as SvgCaretRight, Warning } from 'phosphor-react'
import React, { useEffect } from 'react'
import { Button, Typography } from '@lightbeamai/design-system'

const ButtonGroup = (props) => {
  return (
    <div className="widget-alert-summary carousel-button-group">
      <button onClick={() => props.previous()} className="arrow left btn-text">
        <SvgCaretLeft size="1rem" weight="bold" color="var(--color-alerts-arrows)" />
      </button>
      <div className="pagination">
        {props.carouselState.currentSlide + 1} of {props.totalPages}
      </div>
      <button onClick={() => props.next()} className="arrow right btn-text">
        <SvgCaretRight size="1rem" weight="bold" color="var(--color-alerts-arrows)" />
      </button>
    </div>
  )
}

const ALERTS_PER_SLIDE = 3

interface OwnProps {
  useMockData?: boolean
  partnerIds?: string[]
  activePartnerId?: string
  widgetDatasourceId?: string
  widgetDatasourceType?: DATA_SOURCE_TYPES
  widgetDashboardId?: string
}

interface StateProps {
  widget?: AlertStaled[]
  list?: AlertCritical[]
  folderId?: string
  parentLink?: string
  className?: string
  showChart?: boolean
  showLoader: boolean
}

interface DispatchProps {
  fetchAlertsStaledWidget: (params: AlertsSummaryParams) => void
  fetchAlertsCritical: (params: AlertsSummaryParams) => void
  resetWidget: () => void
}

type AlertsSummaryComponentProps = StateProps & DispatchProps & OwnProps

const mapAlertNames = {
  TODAY: 'alerts.widget.today',
  AGE_1_7: 'alerts.widget.1_7',
  AGE_8_14: 'alerts.widget.8_14',
  AGE_15_30: 'alerts.widget.15_30',
  AGE_30_: 'alerts.widget.gt_30',
  AGE_GT_30: 'alerts.widget.gt_30'
}

const AlertsSummary = ({
  widget = [],
  list = [],
  showChart = true,
  className = '',
  folderId = '',
  parentLink,
  showLoader,
  widgetDatasourceId,
  widgetDatasourceType,
  widgetDashboardId,
  fetchAlertsStaledWidget,
  fetchAlertsCritical,
  resetWidget,
  partnerIds = [],
  activePartnerId = '',
  useMockData = false
}: AlertsSummaryComponentProps): React.ReactElement => {
  const intl = useIntl()
  const context = useUrlContext()
  const datasourceId = widgetDatasourceId
    ? widgetDatasourceId
    : context.contextFilters[DATA_SOURCE_ID]
  const databaseId = context.contextFilters[DATABASE_ID]
  const datasourceType = widgetDatasourceType
    ? widgetDatasourceType
    : context.queryParams[DATA_SOURCE_TYPE] || ''
  const driveId = context.contextFilters[DRIVE_ID] || ''
  const bucketName = context.contextFilters.bucketId || ''

  useEffect(() => {
    if (useMockData) return
    const params: AlertsSummaryParams = {}
    const filters: FilterParams = {
      filter: [
        {
          key: 'STATUS',
          values: [
            ALERT_STATUS_API_MAP[ALERT_STATUS.active],
            ...alertIntermediateStatuses.map((status) => ALERT_STATUS_API_MAP[status])
          ]
        }
      ]
    }
    if (filters.filter) {
      if (driveId) {
        filters.filter.push({
          key: 'DRIVE_IDS',
          values: [driveId]
        })
      }
      if (bucketName) {
        filters.filter.push({
          key: 'BUCKET_NAMES',
          values: [bucketName]
        })
      }
      folderId &&
        filters.filter.push({
          key: 'LB_FOLDER_IDS',
          values: [folderId]
        })
      if (partnerIds && partnerIds.length) {
        filters.filter.push({
          key: FILTER_PARTNER_ID_KEY,
          values: partnerIds
        })
      }

      params.filters = filters
    }
    if (datasourceId) {
      params.datasourceId = datasourceId
    }
    if (databaseId) {
      params.databaseId = databaseId
    }

    fetchAlertsCritical({
      ...params,
      [UNIQUE_WIDGET_INDEX]: getUniqueWidgetIndex(widgetDashboardId, widgetDatasourceId)
    })
    showChart &&
      fetchAlertsStaledWidget({
        ...params,
        [UNIQUE_WIDGET_INDEX]: getUniqueWidgetIndex(widgetDashboardId, widgetDatasourceId)
      })
  }, [
    datasourceId,
    databaseId,
    driveId,
    showChart,
    bucketName,
    folderId,
    activePartnerId,
    partnerIds.length,
    fetchAlertsStaledWidget,
    fetchAlertsCritical
  ])

  useEffect(() => () => resetWidget(), [resetWidget])

  const totalAlerts = widget.reduce((acc, current) => (acc += current.value), 0) || 0
  /**Todo integrate this */
  const unassignedAlerts = 0
  const percentage = Math.round(((totalAlerts - unassignedAlerts) / totalAlerts) * 100) || 0

  // 3 items per slide
  const slidesList: Array<AlertCritical[]> = []
  for (let i = 0; i < list.length; i += ALERTS_PER_SLIDE) {
    slidesList.push(list.slice(i, i + ALERTS_PER_SLIDE))
  }

  const widgetData = widget.map((item) => ({
    name: intl.formatMessage({ id: mapAlertNames[item.name] || 'alerts.widget.gt_30' }),
    value: item.value
  }))

  const handleGoToUnresolvedAlerts = () => {
    if (parentLink) {
      changeUrl(parentLink + URL_ALERTS)
    } else {
      const link = getUpdatedUrl({
        pathName: URL_POLICIES + URL_ALERTS,
        pageName: URL_ALERTS,
        pageQueryParams: {
          [PAGE_VIEW_KEY]: PAGE_VIEW_VALUES.list,
          [IS_UNRESOLVED]: true,
          ...(datasourceType ? { [FILTER_DATA_SOURCE_TYPE_KEY]: datasourceType } : {})
        },
        resetPageQuery: true,
        resetQuery: true
      })

      window.open(link, '_blank')
    }
  }

  return (
    <div className="lb-widget-card alerts-summary  xs-p-16">
      <div
        className={`alerts-summary-widget ${className} `}
        data-test-id="alerts-alerts-summary-widget"
      >
        <Typography className="xs-mb-24" color="primary" variant="h6">
          {intl.formatMessage({ id: 'alerts.widget.title' })}
        </Typography>
        {widget && showChart && (
          <ChartBarSimple
            data={widgetData}
            onClick={handleGoToUnresolvedAlerts}
            barColor={ChartColors.Orange}
            xAxisAngle={0}
            tickFormatter={{ fontSize: '0.72rem', fill: ChartColors.SecondaryText }}
            className="v2-chart"
            xLabel={intl.formatMessage({ id: 'alerts.widget.xLabel' })}
            yLabel={intl.formatMessage({ id: 'alerts.widget.yLabel' })}
            xAxisLabelPadding={{ dx: -24, dy: 12 }}
            chartMargin={{ top: 5, right: 30, left: 20, bottom: 20 }}
            xAxisLine={true}
          />
        )}
        <div className="assigned-alerts-wrapper xs-mb-24 lg-mb-0">
          <div
            className="assigned-alerts-progress xs-mt-24 xs-mb-8"
            onClick={handleGoToUnresolvedAlerts}
          >
            <div className="progress-completed" style={{ width: percentage + '%' }} />
          </div>
          <div className="total" onClick={handleGoToUnresolvedAlerts}>
            <Typography color="primary" type="medium" variant="base">
              {totalAlerts} {intl.formatMessage({ id: 'alerts.widget.alerts' })}
            </Typography>
          </div>
        </div>
        {slidesList.length ? (
          <div className="critical-alerts">
            <div className="line-divider" />
            <Typography className="xs-mb-8" color="primary" variant="h6">
              {intl.formatMessage({ id: 'alerts.widget.criticalAlerts' })}
            </Typography>

            <div className="carousel-wrapper">
              <Carousel
                swipeable
                keyBoardControl
                draggable={false}
                showDots={false}
                responsive={{
                  mobile: {
                    breakpoint: { max: 5000, min: 0 },
                    items: 1,
                    slidesToSlide: 1
                  }
                }}
                autoPlay={false}
                autoPlaySpeed={1000}
                transitionDuration={300}
                containerClass="carousel-container"
                sliderClass="xs-px-0"
                dotListClass="custom-dot-list-style"
                itemClass=""
                arrows={false}
                renderButtonGroupOutside
                customButtonGroup={<ButtonGroup totalPages={slidesList.length} />}
              >
                {slidesList.map((slideArray, i) => {
                  return (
                    <div className="alerts-slide" key={i}>
                      {slideArray.map((alert) => {
                        const getAlertUrl = (datasourceId: string, assignees: string[]) => {
                          if (parentLink) {
                            return parentLink + URL_ALERTS
                          }
                          const assigneesStr = assignees.filter((a) => a.length > 0).join(',')
                          const link = getUpdatedUrl({
                            pathName: `${URL_POLICIES}${URL_ALERTS}/${alert.id}${URL_OVERVIEW}`,
                            pageName: URL_ALERTS,
                            pageQueryParams: {
                              [PAGE_VIEW_KEY]: PAGE_VIEW_VALUES.list,
                              [IS_UNRESOLVED]: true,
                              ...(datasourceType
                                ? {
                                    [FILTER_DATA_SOURCE_TYPE_KEY]: datasourceType
                                  }
                                : {})
                            },
                            queryParams: {
                              datasourceId,
                              assignee: assigneesStr
                            },
                            resetPageQuery: true,
                            resetQuery: true
                          })

                          return link
                        }

                        return (
                          <a
                            className="item xs-pt-16"
                            key={alert.id}
                            href={getAlertUrl(alert.dataSourceId, alert.assignees)}
                            target="_blank"
                            rel="noreferrer"
                            data-test-id="alerts-summary-widget-alert"
                          >
                            <div className="left">
                              <Warning size={16} color={ChartColors.DarkRed} weight="fill" />
                            </div>
                            <div className="right">
                              <div className="info">
                                <Typography className="xs-mb-0" color="primary" type="normal">
                                  {alert.name}
                                </Typography>
                                <Typography color="placeholder" type="normal" variant="baseMinus2">
                                  {formatDateTimeStringToPrettyDateTimeWithoutPrefix(
                                    alert.generatedAt
                                  )}
                                </Typography>
                              </div>
                              <Button
                                className="alerts-summary-assign"
                                variant="link"
                                data-test-id="alerts-summary-widget-btn-assign"
                              >
                                {intl.formatMessage({ id: 'widget.viewDetails' })}
                              </Button>
                            </div>
                          </a>
                        )
                      })}
                    </div>
                  )
                })}
              </Carousel>
            </div>
          </div>
        ) : (
          <div className="entity-empty-state">
            <div className="icon-box">
              <NoAlertsSvg />
            </div>
            <Typography color="placeholder" type="medium" className="xs-mt-16 xs-mb-4  ">
              {intl.formatMessage({ id: 'dashboard.widget.noAlertsTitle' })}
            </Typography>

            <Typography variant="baseMinus2" type="medium" color="placeholder">
              {intl.formatMessage({ id: 'dashboard.widget.noAlertsText' })}
            </Typography>
          </div>
        )}
        <LoaderView showLoader={showLoader} />
      </div>
    </div>
  )
}

const mapStateToProps = (state: RootState, ownProps: OwnProps): StateProps => ({
  widget: ownProps?.useMockData
    ? mockAlertSummaryWidgetData.widget
    : state.alerts.widgetDataStaled?.[
        getUniqueWidgetIndex(ownProps.widgetDashboardId, ownProps.widgetDatasourceId)
      ] || [],
  list: ownProps?.useMockData
    ? (mockAlertSummaryWidgetData.list as AlertCritical[])
    : state.alerts.widgetDataListCritical?.[
        getUniqueWidgetIndex(ownProps.widgetDashboardId, ownProps.widgetDatasourceId)
      ] || [],
  showLoader: getShowLoader(ACTION_ALERTS_STALED_WIDGET)
})

const mapDispatchToProps: DispatchProps = {
  fetchAlertsStaledWidget,
  fetchAlertsCritical,
  resetWidget
}

export default connect<StateProps, DispatchProps, OwnProps, RootState>(
  mapStateToProps,
  mapDispatchToProps
)(AlertsSummary)
